/* AQ — Mesure, v1, 2026-09-08. Huit gestes qui disent si le tronc commun sert à
   chercher : lentille choisie, pastille du tronc commun ouverte, valeur choisie,
   « Tout voir », recherche ouverte, résultat cliqué, favori, demande envoyée.
   Chaque geste part vers Shopify (Shopify.analytics.publish, lu par les pixels
   web) et vers window.dataLayer s'il existe. Aucun texte visible, aucun cookie,
   aucune donnée personnelle : le nom du geste, l'étiquette cliquée, la page. */
(function(){
  function send(name, data){
    var ev = Object.assign({page: location.pathname, type: (document.body && document.body.dataset && document.body.dataset.aqPage) || ''}, data || {});
    try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('aq_' + name, ev); }catch(e){}
    try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({event: 'aq_' + name}, ev)); }catch(e){}
  }
  window.aqMesure = send;
  var MAP = [
    ['[data-aq-mesure]', function(el){ return [el.getAttribute('data-aq-mesure'), {libelle: (el.textContent||'').trim().slice(0,80)}]; }],
    ['.aq4__tc, .aq-tc, .aqtc__chip', function(el){ return ['pastille', {libelle: (el.textContent||'').trim().slice(0,80)}]; }],
    ['.aqhf__chip, .aqpl .aqhf__chip', function(el){ return ['lentille', {libelle: (el.textContent||'').trim().slice(0,80)}]; }],
    ['.aqpl__suba', function(el){ return ['valeur', {libelle: (el.textContent||'').trim().slice(0,80)}]; }],
    ['.aq-bh__all', function(el){ return ['tout_voir', {vers: el.getAttribute('href') || ''}]; }],
    ['.aq-search, [data-aq-palette-open], .aq-entete__pilule', function(el){ return ['recherche_ouverte', {}]; }],
    ['.aq-palette__item, .aqsp__item, [data-aq-palette-result]', function(el){ return ['resultat', {vers: el.getAttribute('href') || ''}]; }],
    ['[data-aq-fav], .aq-fav__btn, .aq-favoris__add', function(el){ return ['favori', {}]; }],
    ['.aq-req__send, [data-aq-request-send]', function(el){ return ['demande', {}]; }]
  ];
  document.addEventListener('click', function(e){
    for (var i=0;i<MAP.length;i++){
      var el = e.target.closest && e.target.closest(MAP[i][0]);
      if (el){ var r = MAP[i][1](el); send(r[0], r[1]); return; }
    }
  }, true);
})();
